/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Col, Row, Form, Button, Layout, message } from "antd";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import LayoutBreadCrumb from "../00_Nav/layout/layout_bread_crumb";
import { useMenu } from "../../hook/useMenu";
import ForgotEmail from "./component/forgot_email";
import {
  resetPassword,
  resetPasswordAccount,
} from "../../store/auth/auth.action";

const { Content } = Layout;

const ForgotScreen = () => {
  // -------------------------- VAR --------------------------
  const [form] = Form.useForm();
  const { breadCrumb } = useMenu();
  const { t } = useTranslation("translation", { keyPrefix: "forgot" });
  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------

  const onFinish = (values) => {
    setLoading(true);
    const email = values.email;
    dispatch(
      resetPasswordAccount({ email }, (response) => {
        setLoading(false);
        if (response?.status === 200) {
          // failed
          const success = "Email sent successfully!";
          message.success(success);
        }
        if (response?.status === 500) {
          // failed
          const error = response.data;
          message.error(error);
        }
      })
    );
  };

  const onFinishFailed = (error) => {
    console.log({ error });
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------

  const renderResetForm = () => {
    const disabled = loading;
    return (
      <Form
        name="reset_form"
        autoComplete="off"
        form={form}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[16, 0]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <ForgotEmail disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button form-button"
                style={{ marginBottom: 10, width: "100%" }}
                loading={loading}
              >
                {t("reset")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="full">
      <Content className="content">
        <Row style={{ margin: "0px 0px 40px" }} align="center">
          <LayoutBreadCrumb data={breadCrumb?.forgot} />
        </Row>
        <Row gutter={[16, 16]} justify="center">
          <Col xxl={8} xl={8} lg={8} md={8} xs={24}>
            {renderResetForm()}
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default ForgotScreen;
